import React, { Fragment, Component } from "react";
import styled from "styled-components";

const ShadowHashlink = styled.div`
  position: absolute;
  top: ${props => props.offset};
  width: 100%;

  @media (max-width: 500px) {
    top: ${props => props.mobileOffset};
  }
`;

export default props => {
  let { id, offset, mobileOffset } = props;
  //setting default offset
  if (offset === undefined) {
    offset = "-50%";
  }

  if (mobileOffset === undefined) {
    mobileOffset = "-50%";
  }

  return <ShadowHashlink id={id} offset={offset} mobileOffset={mobileOffset} />;
};



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/ShadowHashlink.js